const currency = require('./currency-service');
const percent = require('./percent-service');

module.exports = {
    currency,
    percent
};